module.exports = __webpack_public_path__ + "img/todo.e311cc2d.svg";